import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "css/generalSettings.css";
import "css/vehicleDropdownResponsive.css";

const Person = () => {
  const person = useSelector((state) => state.loginUser.defaultEmployee);
  const roles = useSelector((state) => state.loginUser.roles);
  const { t } = useTranslation(["sidebar"]);

  const hasStoresMenu = roles?.[0]?.listmenus?.some((m) => m.name === "SubMenu_Settings_View_Person");
  const hasDriver = Boolean(person?.fullname);

  const vehicles = useMemo(() => {
    return Array.isArray(person?.vehiclestore) ? person.vehiclestore : [];
  }, [person?.vehiclestore]);

  const vehiclesCount = vehicles.length;

  if (!hasStoresMenu) return null;

  return (
    <>
      {/* Conductor + Dropdown vehículos */}
      <li className="nav-item dropdown no-arrow mx-2">
        <button
          type="button"
          className="nav-link dropdown-toggle driver-chip"
          id="vehiclesDropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="driver-icon-wrapper">
            <span className={`driver-icon ${hasDriver ? "driver-icon-ok" : "driver-icon-empty"}`}>
              {hasDriver ? "🚚" : "⛔"}
            </span>
            {vehiclesCount > 0 && (
              <span className="vehicle-badge">
                {vehiclesCount}
              </span>
            )}
          </span>
          <span className={`driver-name ${hasDriver ? "driver-name-ok" : "driver-name-empty"}`}>
            {hasDriver ? person.fullname : t("Text_DriverEmpty")}
          </span>
        </button>
        <div
          className="dropdown-list dropdown-menu dropdown-menu-left shadow animated--grow-in vehicles-dropdown"
          aria-labelledby="vehiclesDropdown"
        >
          <div className="vehicles-header">
            {t("Text_DriverSelected")}
          </div>
          {vehiclesCount === 0 ? (
            <div className="dropdown-item text-muted small py-3">
              {t("Text_VehiclesEmpty")}
            </div>
          ) : (
            vehicles.map((vehicle, index) => (
              <div
                key={vehicle?.id ?? vehicle?.vehiclestore_licenseplate ?? index}
                className="dropdown-item d-flex align-items-center vehicle-item"
              >
                <div className="vehicle-bullet">
                  <span className="vehicle-dot" />
                </div>

                <div className="font-weight-bold">
                  <div className="text-truncate vehicle-plate">
                    {vehicle?.vehiclestore_licenseplate ?? "-"}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </li>
    </>
  );
};

export default Person;
